import { Link } from "@tanstack/react-router";
import { Mail, MessageCircle, Instagram } from "lucide-react";

import { CONTACT, content } from "@/i18n/content";
import { useLang } from "@/i18n/language";
import { portalContent } from "@/i18n/portal";
import { Section, SectionHeading } from "./Primitives";

export function Enroll() {
  const { lang } = useLang();
  const t = content[lang];
  const p = portalContent[lang];

  return (
    <Section id="enroll">
      <div className="grid gap-14 lg:grid-cols-[1.05fr_0.95fr]">
        <div>
          <SectionHeading eyebrow={t.enroll.eyebrow} title={t.enroll.title} lead={t.enroll.lead} />

          <ol className="mt-9 space-y-5">
            {t.enroll.points.map((p, i) => (
              <li key={p.slice(0, 20)} className="flex gap-4">
                <span className="mt-0.5 flex size-7 shrink-0 items-center justify-center rounded-full border border-primary/50 text-xs font-semibold text-primary">
                  {i + 1}
                </span>
                <p className="text-sm leading-relaxed text-muted-foreground">{p}</p>
              </li>
            ))}
          </ol>

          <p className="mt-8 max-w-xl text-xs leading-relaxed text-muted-foreground">
            {t.enroll.disclaimer}
          </p>
        </div>

        <div
          className="rounded-xl border border-border bg-surface p-8"
          style={{ boxShadow: "var(--shadow-lift)" }}
        >
          <h3 className="text-xl font-semibold">{t.enroll.accountTitle}</h3>
          <p className="mt-3 text-sm leading-relaxed text-muted-foreground">{t.enroll.accountBody}</p>

          <div className="mt-6 flex flex-wrap gap-3">
            <Link
              to="/auth"
              className="rounded-full bg-primary px-5 py-2.5 text-sm font-semibold text-primary-foreground transition-opacity hover:opacity-90"
            >
              {p.auth.signUp}
            </Link>
            <Link
              to="/auth"
              className="rounded-full border border-border px-5 py-2.5 text-sm font-semibold transition-colors hover:border-primary hover:text-primary"
            >
              {p.auth.signIn}
            </Link>
          </div>


          <div className="mt-8 space-y-3">
            <p className="eyebrow text-primary">{t.contact.eyebrow}</p>
            <a
              href={CONTACT.whatsappHref}
              target="_blank"
              rel="noreferrer"
              className="flex items-center gap-3 rounded-lg border border-border px-4 py-3 text-sm transition-colors hover:border-primary hover:text-primary"
            >
              <MessageCircle className="size-4 text-primary" />
              {CONTACT.whatsapp}
            </a>
            <a
              href={`mailto:${CONTACT.email}`}
              className="flex items-center gap-3 rounded-lg border border-border px-4 py-3 text-sm transition-colors hover:border-primary hover:text-primary"
            >
              <Mail className="size-4 text-primary" />
              {CONTACT.email}
            </a>
            <a
              href={CONTACT.instagram}
              target="_blank"
              rel="noreferrer"
              className="flex items-center gap-3 rounded-lg border border-border px-4 py-3 text-sm transition-colors hover:border-primary hover:text-primary"
            >
              <Instagram className="size-4 text-primary" />
              {CONTACT.instagramHandle}
            </a>
          </div>

          <p className="mt-8 font-serif text-lg leading-snug text-foreground/85">{t.contact.lead}</p>
        </div>
      </div>
    </Section>
  );
}
